import DadosComplementaresRotas from './dados_complementares/DadosComplementaresRotas'

export default {
    path: 'gestaojuridica',
    name: 'GestaoJuridica',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        DadosComplementaresRotas,
    ]
}
